import { Select, SelectOption } from '@ardoq/select';
import { IconName } from '@ardoq/icons';
import { ReactNode } from 'react';
import { type I18nLocale } from '@ardoq/i18n';

type ComponentTypeSelectProps = {
  label?: ReactNode;
  ariaLabel?: string;
  componentTypeOptions: SelectOption<string>[];
  selectedComponentType: string;
  setSelectedComponentType: (value: string) => void;
  isComponentTypeSelectionDisabled: boolean;
  placeholder: string;
  i18nLocale?: I18nLocale;
};

export const ComponentTypeSelect = ({
  label,
  ariaLabel,
  componentTypeOptions,
  selectedComponentType,
  setSelectedComponentType,
  isComponentTypeSelectionDisabled,
  placeholder,
  i18nLocale,
}: ComponentTypeSelectProps) => {
  return (
    <Select
      // @ts-expect-error this line will complain about passing a potentially null value, but we're doing it anyway
      label={label}
      isClearable
      aria-label={ariaLabel ?? label}
      options={componentTypeOptions}
      value={selectedComponentType}
      onChange={(event: any) => {
        setSelectedComponentType(event?.value ?? '');
      }}
      isDisabled={isComponentTypeSelectionDisabled}
      iconName={IconName.COMPONENT}
      placeholder={placeholder}
      i18nLocale={i18nLocale}
    />
  );
};
